var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-infinite-hits',{class:_vm.typeClassName,scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var insights = ref.insights;
return [_c('ResultItem',{class:("item item-" + _vm.typeClassName),attrs:{"item":item,"type":_vm.type,"store":_vm.store,"insights":insights},on:{"modalInterface":_vm.modalInterface}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }